export default __webpack_public_path__ + "SourceSansPro-SemiBold.ttf";